import { render } from "./EditionPassword.vue?vue&type=template&id=f27d8a7e"
import script from "./EditionPassword.vue?vue&type=script&lang=js"
export * from "./EditionPassword.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__